import { AuthProvider } from "react-oidc-context";
import type { WrapperProps } from "@/components";
import { oidcConfig } from "@/config/oidc";

export function OidcProvider({ children }: WrapperProps) {
  return <AuthProvider {...oidcConfig}>{children}</AuthProvider>;
}
